var objectToString = Object.prototype.toString

module.exports = objectToString



//////////////////
// WEBPACK FOOTER
// ./node_modules/xe-utils/staticObjectToString.js
// module id = TdHP
// module chunks = 17